import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'
import { Button } from 'reactstrap'
import { updateQR } from '../actions/qrs'

class QRList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: {
        code: '',
        customer: '',
        type: '',
        mode: '',
      },
      inputValues: {
        code: '',
        customer: '',
      },
      showButton: false,
      buttonPosition: { x: 0, y: 0 },
      selectedURL: null,
      filterOpen: true
    };

    this.debounceTimer = null;

    this.handleRightClick = this.handleRightClick.bind(this);
    this.handleEnabledToggle = this.handleEnabledToggle.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  goTo(id, e) {
    history.push(`/qrs/${id}`)
  }

  handleEnabledToggle(qr, e) {
    e.stopPropagation();
    const { updateQR } = this.props;
    const newEnabledValue = !qr.Enabled;
    updateQR(qr._id, { Enabled: newEnabledValue });
  }

  componentWillUnmount() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  handleFilterChange(filterKey, value) {
    // Immediate updates for selects (type/mode) — text inputs debounce for performance
    if (filterKey === 'type' || filterKey === 'mode') {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          [filterKey]: value,
        },
      }));
      return;
    }

    // For text inputs: update local input value for instant UI feedback and debounce the filter update
    this.setState((prevState) => ({
      inputValues: {
        ...prevState.inputValues,
        [filterKey]: value,
      },
    }));

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          [filterKey]: value,
        },
      }));
    }, 400);
  }

  returnQrType(type) {

    switch (type) {
      case 'pay': return 'Pago';
      case 'free': return 'Gratis';
      case 'test': return 'Test';
    }

  }

  returnQrMode(mode) {

    switch (mode) {
      case 0: return 'MTO DIARIO';
      case 1: return 'OTO DIARIO SIN PIN';
      case 2: return 'BAQUEIRA';
      case 3: return 'OTO DIARIO CON PIN';
      case 4: return 'RESERVA ANTICIPADA';
    }

  }

  handleRightClick(e, url) {
    e.preventDefault();
    const elementRect = e.target.getBoundingClientRect();
    this.setState({
      showButton: true,
      buttonPosition: {
        x: elementRect.left + window.scrollX,
        y: elementRect.top + window.scrollY,
      },
      selectedURL: url,
    });
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }));
  }

  clearFilters() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.setState({
      filters: { code: '', customer: '', type: '', mode: '' },
      inputValues: { code: '', customer: '' },
    });
  }

  openURL(url, e) {
    e.stopPropagation();
    if (url) {
      window.open(url, '_blank'); // Open the URL in a new tab
    }
  }

  hideButton = () => {
    this.setState({ showButton: false, selectedURL: null });
  }

  handleButtonClick = () => {
    const { selectedURL } = this.state;
    if (selectedURL) {
      // Copy the URL to the clipboard
      navigator.clipboard.writeText(`${selectedURL}`)
        .then(() => {
        })
        .catch(err => {
        });

      this.hideButton(); // Hide the button after clicking
    }
  }

  render() {
    const { filters } = this.state;
    const { qrs, role } = this.props;

    // Apply the filters to filter the qrs array
    const filteredqrs = qrs.filter(qr => {
      const { code: codeFilter, customer: customerFilter, type: typeFilter, mode: modeFilter } = filters;

      if (
        codeFilter &&
        (!qr.Code ||
          !qr.Code.toLowerCase().includes(codeFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        customerFilter &&
        (!qr.Customer.Fullname ||
          !qr.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))
      ) {
        return false;
      }

      if (typeFilter && qr.Type !== typeFilter) {
        return false;
      }

      if (modeFilter !== undefined && modeFilter !== '' && parseInt(modeFilter, 10) !== qr.Mode) {
        return false;
      }

      // If all conditions pass, include the QR in the filtered list
      return true;
    });

    return (
      <div>
        {/* Collapsible filter card — admin only */}
        {role === 'ADMIN' && (
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${this.state.filterOpen ? 'open' : ''}`}></i>
          </div>

          {this.state.filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label htmlFor="filter-code">Código</label>
                  <input id="filter-code" type="text" placeholder="Buscar por código..." value={this.state.inputValues.code} onChange={e => this.handleFilterChange('code', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label htmlFor="filter-customer">Cliente</label>
                  <input id="filter-customer" type="text" placeholder="Buscar por cliente..." value={this.state.inputValues.customer} onChange={e => this.handleFilterChange('customer', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>Tipo</label>
                  <select value={this.state.filters.type || ''} onChange={e => this.handleFilterChange('type', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="pay">Pago</option>
                    <option value="free">Gratis</option>
                    <option value="test">Test</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>Modo</label>
                  <select value={this.state.filters.mode || ''} onChange={e => this.handleFilterChange('mode', e.target.value)}>
                    <option value="">Todos</option>
                    <option value={0}>MTO DIARIO</option>
                    <option value={1}>OTO DIARIO SIN PIN</option>
                    <option value={2}>BAQUEIRA</option>
                    <option value={3}>OTO DIARIO CON PIN</option>
                    <option value={4}>RESERVA ANTICIPADA</option>
                  </select>
                </div>

              </div>
              <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-light" onClick={this.clearFilters}>Limpiar</button>
              </div>
            </div>
          )}
        </div>
        )}

        {/* Header for card list (columns) */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Código</div>
          <div className="qrs-header-col col-status">Habilitado</div>
          <div className="qrs-header-col col-customer">Cliente</div>
          <div className="qrs-header-col col-zone">Zona</div>
          <div className="qrs-header-col col-payments">Tipo</div>
          <div className="qrs-header-col col-nightscan">Modo</div>
          <div className="qrs-header-col col-payments">Ventas</div>
          <div className="qrs-header-col col-versions">Personalización</div>
          <div className="qrs-header-col col-actions">Url</div>
        </div>

        {/* Card list */}
        <div className="qrs-admin-list">
          {filteredqrs
            .sort((a, b) => {
              const fullnameA = a.Customer.Fullname.toLowerCase();
              const fullnameB = b.Customer.Fullname.toLowerCase();
              if (fullnameA < fullnameB) return -1;
              if (fullnameA > fullnameB) return 1;
              return 0;
            })
            .map(qr => {
              const statusClass = qr.Enabled ? 'ENABLED' : 'DISABLED';

              return (
                <div
                  key={qr._id}
                  className="qrs-admin-card"
                  onClick={e => this.goTo(qr._id, e)}
                  onContextMenu={(e) => this.handleRightClick(e, qr.Url)}
                >
                  <div className="qrs-admin-row">
                    <div className={`qrs-admin-status-bar ${statusClass}`}></div>
                    <div className="qrs-admin-content">

                      <div className="qrs-admin-machine-id">
                        <div className="qrs-admin-code">{qr.Code}</div>
                        <div className="qrs-admin-sub">{/* small info if needed */}</div>
                      </div>

                      <div className="qrs-admin-machine-status">
                        <div className="qrs-admin-status-line">
                          <div
                            className={`qrs-toggle ${qr.Enabled ? 'enabled' : 'disabled'}`}
                            onClick={(e) => { e.stopPropagation(); this.handleEnabledToggle(qr, e); }}
                            title={qr.Enabled ? 'Click para deshabilitar' : 'Click para habilitar'}
                          >
                            <div className="qrs-toggle-knob" />
                            <span className="qrs-toggle-label">{qr.Enabled ? 'SÍ' : 'NO'}</span>
                          </div>
                        </div>
                      </div>

                      <div className="qrs-admin-machine-customer">
                        <div className="qrs-admin-customer-name">{qr.Customer.Fullname}</div>
                      </div>

                      <div className="qrs-admin-machine-zone">
                        <div className="qrs-admin-zone">Zona {qr.Zone}</div>
                      </div>

                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-payment-type">{this.returnQrType(qr.Type)}</div>
                      </div>

                      <div className="qrs-admin-machine-nightscan">
                        <div className="qrs-admin-sub">{this.returnQrMode(qr.Mode)}</div>
                      </div>

                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{qr.LastSale}</div>
                      </div>

                      <div className="qrs-admin-machine-versions">
                        {qr.headerConfig ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <div className="qrs-admin-preview-gradient" style={{ background: `linear-gradient(to right, ${qr.headerConfig.primaryColor || '#01315f'}, ${qr.headerConfig.secondaryColor || '#067ddb'})` }} title="Gradiente Header" />
                            <div className="qrs-admin-preview-color" style={{ backgroundColor: qr.headerConfig.backgroundColor || '#f3f3f3' }} title="Color de Fondo" />
                            {qr.headerConfig.logoBase64 && (
                              <i className="fas fa-image" style={{ fontSize: '14px', color: '#888' }} title="Tiene Logo" />
                            )}
                            {(qr.headerConfig.backgroundImage || qr.headerConfig.backgroundSmartphoneImage) && (
                              <i className="fas fa-picture-o" style={{ fontSize: '14px', color: '#888' }} title="Tiene Imagen de Fondo" />
                            )}
                          </div>
                        ) : (
                          <span style={{ color: '#999', fontSize: '12px' }}>-</span>
                        )}
                      </div>

                      <div className="qrs-admin-machine-actions">
                        <button
                          className="qrs-admin-card-action-btn update"
                          onClick={(event) => { event.stopPropagation(); this.openURL(qr.Url, event); }}
                        >
                          <i className="fas fa-link"></i>
                          <span className="d-none d-sm-inline ml-1">Abrir</span>
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {this.state.showButton && (
          <div
            style={{
              position: 'absolute',
              top: `${this.state.buttonPosition.y - 200}px`,
              left: `${this.state.buttonPosition.x - 200}px`,
              zIndex: 1000,
            }}
          >
            <Button
              color="primary"
              className={`btn-baqueira`}
              onClick={() => {
                this.handleButtonClick();
              }}
            >
              <i className="fas fa-door-open d-block ml-auto mr-auto mb-2"></i>
              Copiar URL
            </Button>
            <Button
              color="secondary"
              className={`btn-baqueira`}
              onClick={() => {
                this.hideButton();
              }}
            >
              <i className="fas fa-times d-block ml-auto mr-auto mb-2"></i>
              Cancelar
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
});

const mapDispatchToProps = (dispatch) => ({
  updateQR: bindActionCreators(updateQR, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QRList)